/* @flow */
import type {SearchRequest} from '@homeaway/search-url-parser';

// util method to check whether, given state and data from
export const cannotFilter = (resultsCount: ?number): boolean => {
    return !!(Number.isInteger(resultsCount) && resultsCount === 0);
};

export const canonicalizeSearchRequest = (searchRequest: SearchRequest) => {
    const copy = Object.assign({}, searchRequest);
    // remove nulls and undefineds
    Object.keys(copy).forEach((k) => {
        if (typeof copy[k] === 'undefined' || copy[k] === null) {
            delete copy[k];
        }
    });

    // delete 0s
    ['minPrice', 'maxPrice', 'minBathrooms', 'maxBathrooms'].forEach((k) => {
        if (!copy[k]) {
            delete copy[k];
        }
    });

    // special case for bedrooms since minBedrooms = maxBedrooms = 0 is Studio
    if (copy.minBedrooms !== copy.maxBedrooms) {
        if (copy.minBedrooms === 0) {
            delete copy.minBedrooms;
        }
        if (copy.maxBedrooms === 0) {
            delete copy.maxBedrooms;
        }
    }

    // remove page = 1
    if (copy.page === 1) {
        delete copy.page;
    }

    // sort the filters
    if (copy.filter) {
        copy.filter.sort();
    }

    return copy;
};
